import type { AppDefinition } from '../../types/apps';

export const DashboardAppDefinition: AppDefinition = {
  appId: 'dashboard',
  name: 'Dashboard',
  version: '2.0.0',
  description: 'View AI-generated dashboards with metrics, charts, and tables — and build live dynamic widgets.',
  longDescription: `A structured report viewer **and** a live dynamic-widget canvas.

**Static reports (v1):**
- **Metric cards**: Key numbers with period-over-period change indicators
- **Charts**: Line charts for time-series data, bar charts for categorical rankings
- **Tables**: Sortable data tables with all raw rows
- **Narrative text**: Markdown prose sections for AI-written summaries
- **Live updates**: Sections stream in as the agent generates them

**Dynamic widgets (v2):**
- **Internal entity query / stream** — live view of any entity type, with optional aggregation
- **Run a River tool** — any registered tool's output as a widget, refreshed on interval
- **External API polling** — backend-proxied HTTP with per-user rate limits + SSRF guard
- **External stream (SSE)** — subscribe to a push stream via the backend bridge
- **AI / LLM as data source** — a prompt re-computed on a cron schedule
- **Add-widget menu** — user-authored widgets alongside AI-authored ones
- **Owner election** — one client per dashboard drives pull-refreshes; zero duplicate requests`,

  icon: {
    type: 'phosphor',
    phosphorIcon: 'ChartBar',
    phosphorWeight: 'duotone',
    color: '#0891b2',
  },

  creator: {
    name: 'River',
    verified: true,
  },

  categories: ['Analytics'],
  tags: ['dashboard', 'report', 'analytics', 'charts', 'metrics'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),

  entityTypes: ['Dashboard'],
  component: 'DashboardApp',
  requiresEntity: true,
  requiresProps: false,

  hotkeys: {},
  agenticToolIds: ['dashboard_create', 'dashboard_write', 'report_widget_write'],
  actions: {},
  // No standalone app icon (Dock/Store/CreateMenu Apps section) — "New Dashboard"
  // stays available as a quick-create entry everywhere.
  hidden: true,
};

export default DashboardAppDefinition;
